import { create } from 'zustand';

type State = {};

type Actions = {
  toPrevFeedback: (() => void) | null;
  toNextFeedback: (() => void) | null;
  setToPrevFeedback: (f: (() => void) | null) => void;
  setToNextFeedback: (f: (() => void) | null) => void;
};

const useFeedbackNavigationStore = create<State & Actions>((set, get) => ({
  toPrevFeedback: null,
  toNextFeedback: null,
  setToPrevFeedback(f) {
    set({ toPrevFeedback: f });
  },
  setToNextFeedback(f) {
    set({ toNextFeedback: f });
  },
}));

export default useFeedbackNavigationStore;
